// import axios from 'axios'
import axios from "axios";

export default {
  // get questions of survey
  async getSurvey({ commit }) {
    await axios
      .get(`survey-custom`)
      .then((res) => {
        commit("SURVEY", res.data.survey);
      })
      .catch((err) => {
        // commit("ERROR_SAMSA_ORDER", err.message);
      });
  },

};
